import { IEquipmentWeightInfo, UserExerciseSession } from '../../entities';
import { IEquipmentWeightForExerciseInZone } from './EquipmentWeightCalculator';

export class BandWeightAdjustment {
  protected equipmentWeightsNeedAjusting(
    equipmentAdjustedWeightList: IEquipmentWeightForExerciseInZone[],
  ) {
    return equipmentAdjustedWeightList.length > 1;
  }
  protected getLightestWeight(
    equipmentAdjustedWeightList: IEquipmentWeightForExerciseInZone[],
  ) {
    const weightsInAscendingOrder = equipmentAdjustedWeightList.sort(
      (
        a: IEquipmentWeightForExerciseInZone,
        b: IEquipmentWeightForExerciseInZone,
      ) => {
        return a.adjustedExerciseResistance - b.adjustedExerciseResistance;
      },
    );
    return weightsInAscendingOrder[0];
  }
  protected setEquipmentWeightInfoForExercisesInZone(
    exerciseSession: UserExerciseSession,
    equipmentWeightList: IEquipmentWeightForExerciseInZone[],
    equipmentWeightInfo: IEquipmentWeightInfo,
  ) {
    const exerciseInOrder = exerciseSession.exerciseInOrder();
    const exercisesWithAdjustment = exerciseInOrder.map((exercise, index)=> {
      const clonedExercise = structuredClone(exercise);
      const weightInfoThatNeedsAdjustment = equipmentWeightList.find((weightInfo)=> {
        return weightInfo.indexOfExercise === index;
      });
      if(weightInfoThatNeedsAdjustment) {
        clonedExercise.equipmentWeightInfo = equipmentWeightInfo;
        return clonedExercise;
      }
      return exercise;
    });
    exerciseSession.setExercisesInOrder(exercisesWithAdjustment);
  }
}
